import { defineComponent } from 'vue'
import './style.sass'

export default defineComponent({
  setup () {
    return () => {
      return (
        <div class="empty-list">
          Информация отсутствует
        </div>
      )
    }
  }
})